import { useQuery } from '@pinia/colada';
import { Ref } from 'vue';

import { PortfolioStatisticsFilter } from '../enums/portfolio-statistics-filter.enum';
import portfolioStatisticsService from '../services/portfolio-statistics.service';

export function getPortfolioColdUnitsQueryKey(filter: PortfolioStatisticsFilter) {
  return ['portfolio-cold-units', filter];
}

export function usePortfolioColdUnitsQuery(filter: Ref<PortfolioStatisticsFilter>) {
  return useQuery({
    key: () => getPortfolioColdUnitsQueryKey(filter.value),
    query: () => portfolioStatisticsService.getColdUnits(filter.value),
  });
}
